/*
 *
 * RemoveShelfButton actions
 *
 */

import { action } from 'typesafe-actions';

import ActionTypes from './constants';
import { Shelf } from '../../../lib/modelBuilder/entities/Shelf';

export const addRecentModified = (shelf?: Shelf) =>
  action(ActionTypes.RECENT_MODIFIED_SHELF, { shelf });
